// Vibrant Semantic UI Rainbow Calendar Colors
// Based on the Semantic UI color palette for maximum vibrancy

// Helper function to get text color based on background color luminance
// For light backgrounds, returns a darker version of the color
// For dark backgrounds, returns white
export const getTextColorForBackground = (hexColor) => {
  if (!hexColor) return '#ffffff';

  // Convert hex to RGB
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substr(0, 2), 16);
  const g = parseInt(hex.substr(2, 2), 16);
  const b = parseInt(hex.substr(4, 2), 16);

  // Calculate relative luminance (WCAG formula)
  const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;

  // If luminance > 0.5, it's a light color - use darker version
  if (luminance > 0.5) {
    // Create a darker version of the color (multiply by 0.35)
    const darkR = Math.floor(r * 0.35);
    const darkG = Math.floor(g * 0.35);
    const darkB = Math.floor(b * 0.35);
    return `rgb(${darkR}, ${darkG}, ${darkB})`;
  }

  // Dark background - use white text
  return '#ffffff';
};

// Light colors that need dark text (for quick reference)
export const LIGHT_COLORS = ['#FFD700', '#32CD32', '#FE9A76', '#EE82EE'];

export const CALENDAR_COLORS = {
  // Yellow - luxury gold
  'rich-bitch': '#FFD700',

  // Blue - tech vibes
  'tech-bro': '#0E6EB8',

  // Orange - sunset festival
  'festival-fiend': '#FE9A76',

  // Green - sporty energy
  'sports-superfan': '#016936',

  // Red - wine burgundy
  'wine-mom': '#B03060',

  // Olive - lime green lawn
  'suburban-dad': '#32CD32',

  // Pink - K-pop energy
  'kpop-stan': '#FF1493',

  // Purple - Disney magic
  'disney-adult': '#B413EC',

  // Blue - traditional
  'jewish-holidays': '#0E6EB8',

  // Blue - patriotic
  'all-american': '#0E6EB8',

  // Black - rock vibes
  'rock-metal': '#1a1a1a',

  // Red - Gryffindor
  'potterhead': '#B03060',

  // Yellow - spotlight gold
  'broadway-baby': '#FFD700',

  // Teal - tropical vibes
  'high-season': '#008080',

  // Violet - rainbow pride
  'pride': '#EE82EE',

  // Green - fiesta
  'latino-heritage': '#016936',

  // Red - racing
  'formula-1': '#B03060',

  // Teal - wellness calm
  'wellness-warrior': '#008080',

  // Pink - main character energy
  'chronically-online': '#FF1493',

  // Black - dignified
  'black-excellence': '#1a1a1a',

  // Red - lucky red
  'lunar-aapi': '#B03060',

  // Violet - Y2K nostalgia
  'millennial-nostalgia': '#EE82EE',

  // Yellow - vegas gold
  'vegas-regular': '#FFD700',

  // Purple - cosmic
  'space-enthusiast': '#B413EC',

  // Brown - country roads
  'country-music': '#A52A2A',

  // Orange - sale vibes
  'shopping-seasons': '#FE9A76',

  // Brown - medieval
  'renaissance-faires': '#A52A2A',

  // Orange - fiber warmth
  'fiber-arts': '#FE9A76',
};

// Semantic UI Color Reference Palette
export const SEMANTIC_COLORS = {
  red: '#B03060',
  orange: '#FE9A76',
  yellow: '#FFD700',
  olive: '#32CD32',
  green: '#016936',
  teal: '#008080',
  blue: '#0E6EB8',
  violet: '#EE82EE',
  purple: '#B413EC',
  pink: '#FF1493',
  brown: '#A52A2A',
  grey: '#A0A0A0',
  black: '#1a1a1a',
};
